<template>
	<div class='pagebox'>
		<el-pagination
			@size-change="handleSizeChange"
	      	@current-change="currentChange"
	      	@prev-click="handPrev"
	      	@next-click="handNext"
			background
	      	:current-page="curIndex"
	      	:page-size="pageSize"
	      	:pager-count="7"
	      	layout="total,sizes, prev, pager, next, jumper"
	      	:total="rowsCount">
	    </el-pagination>
	</div>
</template>
<script>
	import { mapState } from 'vuex';

	export default{
		data(){
			return{
				pageSizes:[10,20,30,40,50],
				currentData:{
						pageSize:10,
						pageNumber:1,
					}
			}
		},
		props:{
		  	pageSize: Number//每页显示的条数
		},
		methods:{
			currentChange(curPage){
				this.currentData.pageNumber=curPage
				this.$emit('pagination',this.currentData.pageNumber,this.currentData.pageSize)
				// this.$parent.tableList(curPage);
			},
			handleSizeChange(pageSize){
				this.currentData.pageSize=pageSize
				this.$emit('pagination',this.currentData.pageNumber,this.currentData.pageSize)
			},
			handPrev(){
				// console.log('prev')
			},
			handNext(){
				// console.log('next')
			}
		},
		computed:mapState({
			curIndex: state => state.page.curIndex,//当前页
			rowsCount: state => state.page.rowsCount//总条数
		})
	}
</script>
<style scoped>
	.pagebox{
		position: absolute;
		bottom:0;
		right:30px;
		
	
	}
</style>